'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../_virtual/index.cjs');
var index$1 = require('../../../illustrations/index.cjs');

/**
 * A themed SVG illustration component
 *
 * {@link https://aviary.fullscript.io/latest/components/illustration/web-B8oygjtb | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Illustration/Illustration.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Illustration = ({ illustration, intention = "neutral", size = "medium", customCss, ...rest })=>{
    const assetColor = index.cjsExports.intentionToAssetColor(intention);
    const IllustrationComponent = index$1[illustration];
    if (IllustrationComponent) {
        return /*#__PURE__*/ jsxRuntime.jsx(IllustrationComponent, {
            size: index.cjsExports.ILLUSTRATION_DIMENSIONS[size],
            assetColor: assetColor,
            "data-testid": index.cjsExports.ILLUSTRATION_COMPONENTS[illustration],
            css: customCss,
            ...rest
        });
    }
    return null;
};

exports.Illustration = Illustration;
//# sourceMappingURL=Illustration.web.cjs.map
